import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Link from '@components/link'
import useHover from '@hooks/useHover'
import { CtaText } from '@components/atoms/cta-arrow'
import useStyles from './card-program.styles'

const CardProgram = (props) => {
  const {
    headline,
    summary,
    image,
    ctaText,
    showProgramCollection,
    eventCategory,
    className = '',
    showTags,
    imageWithFocalPoint,
  } = props

  const [hoverRef, isHovered] = useHover()
  const url = imageWithFocalPoint?.image?.url ? `${imageWithFocalPoint.image.url}?w=630&h=420&fl=progressive&q=80` : (image?.url ? `${image.url}?w=630&h=420&fl=progressive&q=80` : '')

  const xPosition = imageWithFocalPoint?.focalPoint?.focalPoint?.x ? `${imageWithFocalPoint.focalPoint.focalPoint.x * 100 / imageWithFocalPoint.image.width}%` : '50%'
  const yPosition = imageWithFocalPoint?.focalPoint?.focalPoint?.y ? `${imageWithFocalPoint.focalPoint.focalPoint.y * 100 / imageWithFocalPoint.image.height}%` : '50%'

  const position = {
    x: xPosition,
    y: yPosition,
  }

  const styles = useStyles({ url, position })

  return (
    <Box ref={hoverRef} className={`${styles.root} ${className}`} data-testid="card-program-root">
      <Link {...props}>
        <Box className={styles.alignment}>
          <Box className={styles.imageContainer} data-testid="card-program-image">
            {showTags && (
              <Box className={styles.tagsRow}>
                <Box className={styles.tagsWrapper} data-testid="card-program-tags">
                  {eventCategory && showProgramCollection && (
                    <Typography variant="body2" className={styles.tag}>{eventCategory.name}</Typography>
                  )}
                </Box>
              </Box>
            )}
          </Box>
          <Box className={styles.cardInfo}>
            <Typography variant="h6" variantMapping={{ h6: 'h3' }} className={styles.headline}>{headline}</Typography>
            <Typography variant="caption" className={styles.fieldText}>{summary}</Typography>
            <CtaText hovered={isHovered} variant="subtitle2" className={styles.cta}>
              {ctaText || 'View More'}
            </CtaText>
          </Box>
        </Box>
      </Link>
    </Box>
  )
}

CardProgram.propTypes = {
  __typename: PropTypes.string,
  headline: PropTypes.string,
  summary: PropTypes.string,
  image: PropTypes.shape({
    description: PropTypes.string,
    url: PropTypes.string,
  }),
  imageWithFocalPoint: PropTypes.shape({
    focalPoint: PropTypes.shape({
      focalPoint: PropTypes.shape({
        x: PropTypes.number,
        y: PropTypes.number,
      }),
    }),
    image: PropTypes.shape({
      url: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
    }),
  }),
  ctaText: PropTypes.string,
  slug: PropTypes.string,
  className: PropTypes.string,
  showProgramCollection: PropTypes.bool,
  eventCategory: PropTypes.shape({
    __typename: PropTypes.string,
    name: PropTypes.string,
  }),
  showTags: PropTypes.bool,
}

export default CardProgram
